"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  ASSOCIATE_COMPANY_AND_DEAL: null,
  ASSOCIATE_COMPANY_AND_ENGAGEMENT: null,
  ASSOCIATE_CONTACT_AND_COMPANY: null,
  ASSOCIATE_CONTACT_AND_DEAL: null,
  ASSOCIATE_CONTACT_AND_ENGAGEMENT: null,
  ASSOCIATE_DEAL_AND_ENGAGEMENT: null,
  ASSOCIATIONS_LOADED: null,
  ASSOCIATION_BATCH_LOADED: null,
  ASSOCIATION_FETCH_FAILED: null,
  ASSOCIATION_FETCH_FINISHED: null,
  ASSOCIATION_FETCH_QUEUED: null,
  ASSOCIATION_LOADED: null,
  DISASSOCIATE_COMPANY_AND_DEAL: null,
  DISASSOCIATE_COMPANY_AND_ENGAGEMENT: null,
  DISASSOCIATE_CONTACT_AND_COMPANY: null,
  DISASSOCIATE_CONTACT_AND_DEAL: null,
  DISASSOCIATE_CONTACT_AND_ENGAGEMENT: null,
  DISASSOCIATE_DEAL_AND_ENGAGEMENT: null,
  ASSOCIATE_TICKET_AND_ENGAGEMENT: null,
  DISASSOCIATE_TICKET_AND_ENGAGEMENT: null
});

exports.default = _default;
module.exports = exports.default;